import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { AfterViewInit, ChangeDetectorRef, Component, Injectable, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs/Observable';
import { JobSummaryService } from './job-summary.service';
import { ExceptionHelper } from './../../../../helper';

import * as $ from 'jquery';
import 'datatables.net';
import 'datatables.net-bs4';

@Component({
  templateUrl: './job-summary.component.html',
  styleUrls: [
    '../../../../../scss/vendors/bs-datepicker/bs-datepicker.scss'
  ],
  encapsulation: ViewEncapsulation.None
})

@Injectable()
export class JobSummaryComponent implements AfterViewInit, OnInit {

  @ViewChild('dangerModal') dangerModal: any;

  activateCheckboxStatus: number;
  completedCheckboxStatus: number;
  // completedCheckbox: Boolean;
  // incompletedCheckbox: Boolean;

  applied: Boolean;
  dataTable: any;
  jobs: any[];

  firstDay: Date = new Date(new Date().getFullYear(), 0, 1);
  bsRangeValue: any = [];

  customerId;

  isCED: Boolean;  // isContractEndDate

  constructor(
    private chRef: ChangeDetectorRef,
    private datePipe: DatePipe,
    private exception: ExceptionHelper,
    private http: HttpClient,
    private route: ActivatedRoute,
    private router: Router,
    private jobSummaryService: JobSummaryService,
    private translate: TranslateService
  ) {
    translate.setDefaultLang('en-us');
    this.route.params.subscribe(params => { this.customerId = params['customerId']; });

  }

  ngAfterViewInit() {
    this.getSummary();
  }

  ngOnInit() {
    this.applied = true;
    this.isCED = false;
  }

  public apply(): void {
    // this.applied = true;
    this.getSummary();
  }

  // public checkboxStatus(input): void {
  //   this.activateCheckboxStatus = input.activateCheckboxStatus;

  //   this.applied = false;
  // }

  public completedboxStatus(input): void {
    this.completedCheckboxStatus = input.completedCheckboxStatus;
    // this.completedCheckbox = input.completedCheckbox;
    // this.incompletedCheckbox = input.incompletedCheckbox;

    this.applied = input.isApply;

    // this.applied = false;
  }

  public checkboxChange(): void {
    this.applied = false;
    this.isCED = !this.isCED;
  }

  public getSummary(): void {
    const all = (this.customerId == null ? true : false);
    let startDate = '';
    let endDate = '';

    if (this.isCED && this.bsRangeValue.length === 2) {
      startDate = this.datePipe.transform(this.bsRangeValue[0], 'yyyy-MM-dd');
      endDate = this.datePipe.transform(this.bsRangeValue[1], 'yyyy-MM-dd');
    }

    this.jobSummaryService
        .getSummary(
          startDate,
          endDate,
          this.completedCheckboxStatus,
          this.activateCheckboxStatus,
          all, this.customerId
        )
        .subscribe((data: any) => {
          this.applied = true;

          if ($.fn.dataTable.isDataTable('#jobDataTables')) {
            $('#jobDataTables').DataTable().destroy();
          }

          this.jobs = data.jobListModel;

          this.chRef.detectChanges();

          const table: any = $('#jobDataTables');
          this.dataTable = table.DataTable();
          // this.applied = false;

        }, err => {
          this.exception.showError(err, 'showDanModalBtn');
          // this.applied = false;
        });
  }
  public onDateRangeChange(): void {
    this.applied = !(this.isCED === true);
  }
  public errorClose(): void {
    if (this.customerId != null) {
      this.router.navigate(['/home/customers/detail/' + this.customerId]);
    }
    else {
      this.dangerModal.hide();
    }
  }

}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/job/job-summary/job-summary.component.ts